/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from 'react';
export default function NotFound() {
  return (
    <article>
      <h1>Not Found</h1>
    </article>
  );
}
